exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb-item+.breadcrumb-item:before{content:\" | \"}#breadcrumbTrail{visibility:hidden}#breadcrumbTrail.ready{visibility:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/scripts/components/breadcrumb/breadcrumb.css
// module id = 40
// module chunks = 0